/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateStripePortalSessionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateStripePortalSessionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreateStripePortalSessionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateStripePortalSessionSecurity$outboundSchema: z.ZodMiniType<
  CreateStripePortalSessionSecurity$Outbound,
  CreateStripePortalSessionSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createStripePortalSessionSecurityToJSON(
  createStripePortalSessionSecurity: CreateStripePortalSessionSecurity,
): string {
  return JSON.stringify(
    CreateStripePortalSessionSecurity$outboundSchema.parse(
      createStripePortalSessionSecurity,
    ),
  );
}

/** @internal */
export type CreateStripePortalSessionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateStripePortalSessionRequest$outboundSchema: z.ZodMiniType<
  CreateStripePortalSessionRequest$Outbound,
  CreateStripePortalSessionRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function createStripePortalSessionRequestToJSON(
  createStripePortalSessionRequest: CreateStripePortalSessionRequest,
): string {
  return JSON.stringify(
    CreateStripePortalSessionRequest$outboundSchema.parse(
      createStripePortalSessionRequest,
    ),
  );
}
